// Chaîne de la dépense (M06, lot L4-B, D-141) : besoins des services et leur validation hiérarchique,
// engagements avec contrôle du crédit disponible (refus conservé, dérogation du maire), service fait,
// liquidations avec facture, mandats ordonnancés par le maire ou son délégué, paiements confirmés
// avec la référence du comptable public. Le budget suivi est le plus récent (exécutoire de préférence).
import { Plus } from 'lucide-react';
import { Bouton, Bandeau } from '@cc/ui';
import { useState } from 'react';
import { EnTetePage } from '../../commun/EnTetePage';
import { EtatRequete } from '../../commun/EtatRequete';
import { useSession } from '../../session/FournisseurSession';
import { peut } from '../../session/permissions';
import { useBesoins, useBudgets, useEngagements, useLignes, useLiquidations, useMandats } from './api';
import { FormulaireBesoin } from './FormulairesDepense';
import { NavigationBudget } from './NavigationBudget';
import { SectionBesoins, SectionEngagements, SectionMandats } from './SectionsDepense';

export function PageDepense() {
  const { contexte } = useSession();
  const budgets = useBudgets();
  const liste = budgets.data?.elements ?? [];
  const budget = liste.find((b) => b.etat === 'executoire') ?? liste[0] ?? null;
  const id = budget?.id ?? null;
  const lignes = useLignes(id);
  const besoins = useBesoins();
  const engagements = useEngagements(id);
  const liquidations = useLiquidations(id);
  const mandats = useMandats(id);
  const [creation, setCreation] = useState(false);
  const fictif = budget?.fictif ?? false;
  return (
    <>
      <EnTetePage
        etiquette="Finances et budget"
        titre="Chaîne de la dépense"
        description={budget ? `Budget ${budget.exercice}${fictif ? ' (fictif)' : ''} : besoin, validation, engagement, service fait, liquidation, mandat, paiement confirmé. La plateforme ne paie jamais.` : 'Aucun budget : les engagements exigent un budget exécutoire.'}
        actions={peut(contexte, 'depense', 'creer') ? <Bouton variante="principal" icone={Plus} onClick={() => setCreation(true)}>Exprimer un besoin</Bouton> : null}
      />
      <NavigationBudget actif="depense" />
      {budget && budget.etat !== 'executoire' ? <Bandeau type="info">Le budget {budget.exercice} n&apos;est pas exécutoire : aucun engagement n&apos;est possible avant sa transmission.</Bandeau> : null}
      <EtatRequete chargement={besoins.isPending} erreur={besoins.error} onReessayer={() => void besoins.refetch()} lot="L4-B" fonction="La chaîne de la dépense">
        <SectionBesoins besoins={besoins.data?.elements ?? []} lignes={lignes.data?.elements ?? []} fictif={fictif} contexte={contexte} executoire={budget?.etat === 'executoire'} />
        <SectionEngagements engagements={engagements.data?.elements ?? []} fictif={fictif} contexte={contexte} />
        <SectionMandats liquidations={liquidations.data?.elements ?? []} mandats={mandats.data?.elements ?? []} fictif={fictif} contexte={contexte} />
      </EtatRequete>
      {creation ? <FormulaireBesoin onFermer={() => setCreation(false)} /> : null}
    </>
  );
}
